const ALLOWED_ABSOLUTE_NEXT_HOSTS: ReadonlySet<string> = new Set([
  "artifacts.replo.app",
  "artifacts.staging-apps.replo.app",
  "dashboard.replo.app",
  "www.dashboard.replo.app",
]);

/**
 * Auth screens send the signed-in user to `next` with `window.location.replace`,
 * so an unchecked absolute URL is an open redirect carrying a fresh session.
 * Resolving against the current origin, as the browser will, also catches
 * protocol-relative and whitespace-smuggled hosts. Same-origin covers local dev
 * (artifacts are served under the dashboard's Caddy origin), ngrok tunnels and
 * Vercel previews.
 */
export function isAllowedNextUrl(next: string, currentOrigin: string): boolean {
  let url: URL;
  try {
    url = new URL(next, currentOrigin);
  } catch {
    return false;
  }
  if (url.origin === currentOrigin) {
    return true;
  }
  return (
    url.protocol === "https:" && ALLOWED_ABSOLUTE_NEXT_HOSTS.has(url.hostname)
  );
}
